import type { ModuleDefinition } from "../types";
import { BILLING_READ } from "./permissions";

const screens = () => import("./screens");

/** Member accounts, posting, payments and billing settings. */
export const billingModule: ModuleDefinition = {
  id: "billing",
  labelKey: "module.billing",
  nav: [
    { id: "billing-accounts", labelKey: "billing.nav.accounts", to: "/billing/accounts", icon: "log", permission: BILLING_READ },
    { id: "billing-settings", labelKey: "billing.nav.settings", to: "/billing/settings", icon: "sliders", permission: BILLING_READ, backOffice: { when: ["billing.post", "billing.payments"], unless: ["billing.settings", "billing.runs", "billing.close", "billing.adjust"] } },
  ],
  routes: [
    { path: "billing", permission: BILLING_READ, load: async () => ({ default: (await screens()).AccountsRedirect }) },
    { path: "billing/accounts", permission: BILLING_READ, load: async () => ({ default: (await screens()).AccountsPage }) },
    { path: "billing/accounts/:householdId", permission: BILLING_READ, load: async () => ({ default: (await screens()).AccountPage }) },
    { path: "billing/settings", permission: BILLING_READ, load: async () => ({ default: (await screens()).SettingsIndexRedirect }) },
    { path: "billing/settings/departments", permission: BILLING_READ, load: async () => ({ default: (await screens()).DepartmentsPage }) },
    { path: "billing/settings/items", permission: BILLING_READ, load: async () => ({ default: (await screens()).ItemsPage }) },
    { path: "billing/settings/taxes", permission: BILLING_READ, load: async () => ({ default: (await screens()).TaxesPage }) },
    { path: "billing/settings/rules", permission: BILLING_READ, load: async () => ({ default: (await screens()).RulesPage }) },
    { path: "billing/settings/minimums", permission: BILLING_READ, load: async () => ({ default: (await screens()).MinimumsPage }) },
    { path: "billing/settings/arrangements", permission: BILLING_READ, load: async () => ({ default: (await screens()).ArrangementsPage }) },
    { path: "billing/settings/messages", permission: BILLING_READ, load: async () => ({ default: (await screens()).MessagesPage }) },
    { path: "billing/settings/reasons", permission: BILLING_READ, load: async () => ({ default: (await screens()).ReasonsPage }) },
    { path: "billing/settings/chart", permission: BILLING_READ, load: async () => ({ default: (await screens()).ChartPage }) },
  ],
};
